import { render, staticRenderFns } from "./PlayerMoments.vue?vue&type=template&id=2a6bec3e&scoped=true&"
import script from "./PlayerMoments.vue?vue&type=script&lang=js&"
export * from "./PlayerMoments.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMoments.vue?vue&type=style&index=0&id=2a6bec3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bec3e",
  null
  
)

export default component.exports